export default "__VITE_PUBLIC_ASSET__66362d66__"